import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const StyledDashedLine = styled(Box, {
  shouldForwardProp: (prop) => !["gap, width, height"].includes(prop),
})(({ gap = 13, width = 9, height = 1 }) => {
  const dash = width;
  const space = gap;
  const cycle = dash + space;
  const color = "rgba(0,0,0,0.2)";

  return {
    height: `${height}px`,
    width: "100%",
    backgroundImage: `
      repeating-linear-gradient(90deg, ${color}, ${color} ${dash}px, transparent ${dash}px, transparent ${cycle}px)
    `,
    backgroundSize: `${cycle}px ${height}px`,
    backgroundPosition: "0 0",
    backgroundRepeat: "repeat-x",
    border: "none",
  };
});
